import React from "react";
import {FormattedMessage} from "react-intl";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

// Customer portrait placeholders — drop the real images into public/images/.
// If an image is missing it gracefully degrades to a plain grey circle.
const avatars = [
    "/images/jamie_portrait.png",
    "/images/kevin_portrait.png",
    "/images/maria_portrait.png",
    "/images/lukas_portrait.png",
    "/images/sophie_portrait.png",
];

const hideOnError = (event) => {
    event.currentTarget.style.display = "none";
};

const TestimonialsAvatars = () => (
    <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
        <div className="flex -space-x-3">
            {avatars.map((src) => (
                <span
                    key={src}
                    className="inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-slate-200 ring-2 ring-white"
                >
                    <img
                        src={src}
                        alt=""
                        loading="lazy"
                        onError={hideOnError}
                        className="h-full w-full object-cover"
                    />
                </span>
            ))}
        </div>
        <div className="flex flex-col gap-1">
            <div className="flex text-amber-400" aria-hidden>
                {[0, 1, 2, 3, 4].map((index) => (
                    <StarRoundedIcon key={index} className="h-5 w-5"/>
                ))}
            </div>
            <p className="max-w-md text-sm leading-relaxed text-slate-600">
                <FormattedMessage
                    id="sepaheld.hero.socialproof"
                    defaultMessage="Over 1000+ businesses and freelancers already trust SepaHeld to handle their direct debits automatically."
                />
            </p>
        </div>
    </div>
);

export default TestimonialsAvatars;
